{
  "name": "bluewings-web-admin",
  "version": "8.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "node --max-old-space-size=5120  ./node_modules/@angular/cli/bin/ng build --configuration production --build-optimizer --output-hashing=all",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.4",
    "@angular/cdk": "^17.3.4",
    "@angular/common": "^17.3.4",
    "@angular/compiler": "^17.3.4",
    "@angular/core": "^17.3.4",
    "@angular/forms": "^17.3.4",
    "@angular/platform-browser": "^17.3.4",
    "@angular/platform-browser-dynamic": "^17.3.4",
    "@angular/router": "^17.3.4",
    "@fullcalendar/angular": "^6.1.15",
    "@fullcalendar/core": "^6.1.15",
    "@fullcalendar/daygrid": "^6.1.15",
    "@fullcalendar/interaction": "^6.1.15",
    "@fullcalendar/timegrid": "^6.1.15",
    "@ng-select/ng-select": "^14.1.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@phosphor-icons/web": "^2.1.2",
    "@primeuix/styled": "^0.7.2",
    "@primeuix/utils": "^0.6.1",
    "an-country-code-selector": "github:rishabh-synclovis/an-country-code-selector#main",
    "angular-mobilenumber-countrycode-dropdown": "^1.0.2",
    "chart.js": "^4.4.2",
    "country-flags-svg": "^2.0.0-beta.1",
    "country-state-city": "^3.2.1",
    "currency-list": "^1.0.8",
    "dayjs": "^1.11.21",
    "file-saver": "^2.0.5",
    "iso-country-currency": "^0.7.2",
    "libphonenumber-js": "^1.11.7",
    "lottie-web": "^5.12.2",
    "moment": "^2.30.1",
    "multiselect-dropdown": "^2.0.2",
    "ng-full-calendar": "github:rishabh-synclovis/ng-full-calendar#dist",
    "ng-multiselect-dropdown": "^1.0.0",
    "ngx-daterangepicker-material": "^6.0.4",
    "ngx-lottie": "^11.0.2",
    "pdfjs-dist": "^3.11.174",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.15",
    "rxjs": "~7.8.1",
    "socket.io-client": "^4.8.3",
    "to-words": "^4.2.0",
    "tslib": "^2.6.2",
    "xlsx-js-style": "^1.2.0",
    "zone.js": "~0.14.4"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.4",
    "@angular/cli": "^17.3.4",
    "@angular/compiler-cli": "^17.3.4",
    "@angular/language-service": "^17.3.4",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^20.12.7",
    "baseline-browser-mapping": "^2.10.43",
    "codelyzer": "^6.0.2",
    "jasmine-core": "~5.1.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "ts-node": "~10.9.2",
    "tslint": "~6.1.0",
    "typescript": "~5.4.5"
  }
}